const { VUE_APP_GRAPHQL_HOST } = process.env
import fetch from 'node-fetch'

const getUsersSlugs = async () => {
  console.log('Fetching users slugs')

  const res = await fetch(VUE_APP_GRAPHQL_HOST + 'build/users-slugs', {
    method: 'POST'
  })

  return await res.json()
}

export default getUsersSlugs
